/* src/app/modules/user/partnersequity/social-capital/social-capital-delete.component.css */
/*# sourceMappingURL=social-capital-delete.component.css.map */
